import { PathOptions } from "leaflet";

export const sitios_arqueologicos = (feature: any): PathOptions => {
  return {
    color: "#8B4513",
    weight: 2,
    opacity: 1,
    fillColor: "#D2691E",
    fillOpacity: 0.7,
  };
};
